/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Language_CsInputs */

const en_nav_language_cs = /** @type {(inputs: Nav_Language_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čeština`)
};

const es_nav_language_cs = /** @type {(inputs: Nav_Language_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čeština`)
};

const de_nav_language_cs = /** @type {(inputs: Nav_Language_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čeština`)
};

const zh_nav_language_cs = /** @type {(inputs: Nav_Language_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čeština`)
};

const ar_nav_language_cs = /** @type {(inputs: Nav_Language_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čeština`)
};

const fr_nav_language_cs = /** @type {(inputs: Nav_Language_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čeština`)
};

const vi_nav_language_cs = /** @type {(inputs: Nav_Language_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čeština`)
};

const sw_nav_language_cs = /** @type {(inputs: Nav_Language_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čeština`)
};

const th_nav_language_cs = /** @type {(inputs: Nav_Language_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čeština`)
};

const bs_nav_language_cs = /** @type {(inputs: Nav_Language_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čeština`)
};

const ja_nav_language_cs = /** @type {(inputs: Nav_Language_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čeština`)
};

const ko_nav_language_cs = /** @type {(inputs: Nav_Language_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čeština`)
};

const pt_nav_language_cs = /** @type {(inputs: Nav_Language_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čeština`)
};

const it_nav_language_cs = /** @type {(inputs: Nav_Language_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čeština`)
};

const sv_nav_language_cs = /** @type {(inputs: Nav_Language_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čeština`)
};

const nl_nav_language_cs = /** @type {(inputs: Nav_Language_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čeština`)
};

const da_nav_language_cs = /** @type {(inputs: Nav_Language_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čeština`)
};

const nb_nav_language_cs = /** @type {(inputs: Nav_Language_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čeština`)
};

const fi_nav_language_cs = /** @type {(inputs: Nav_Language_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čeština`)
};

const pl_nav_language_cs = /** @type {(inputs: Nav_Language_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čeština`)
};

const ru_nav_language_cs = /** @type {(inputs: Nav_Language_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čeština`)
};

const tr_nav_language_cs = /** @type {(inputs: Nav_Language_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čeština`)
};

const hi_nav_language_cs = /** @type {(inputs: Nav_Language_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čeština`)
};

const id_nav_language_cs = /** @type {(inputs: Nav_Language_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čeština`)
};

const ms_nav_language_cs = /** @type {(inputs: Nav_Language_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čeština`)
};

const cs_nav_language_cs = /** @type {(inputs: Nav_Language_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čeština`)
};

const el_nav_language_cs = /** @type {(inputs: Nav_Language_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čeština`)
};

const he_nav_language_cs = /** @type {(inputs: Nav_Language_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čeština`)
};

const af_nav_language_cs = /** @type {(inputs: Nav_Language_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čeština`)
};

const hu_nav_language_cs = /** @type {(inputs: Nav_Language_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čeština`)
};

/**
* | output |
* | --- |
* | "Čeština" |
*
* @param {Nav_Language_CsInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_language_cs = /** @type {((inputs?: Nav_Language_CsInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Language_CsInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_language_cs(inputs)
	if (locale === "de") return de_nav_language_cs(inputs)
	if (locale === "zh") return zh_nav_language_cs(inputs)
	if (locale === "ar") return ar_nav_language_cs(inputs)
	if (locale === "fr") return fr_nav_language_cs(inputs)
	if (locale === "vi") return vi_nav_language_cs(inputs)
	if (locale === "sw") return sw_nav_language_cs(inputs)
	if (locale === "th") return th_nav_language_cs(inputs)
	if (locale === "bs") return bs_nav_language_cs(inputs)
	if (locale === "ja") return ja_nav_language_cs(inputs)
	if (locale === "ko") return ko_nav_language_cs(inputs)
	if (locale === "pt") return pt_nav_language_cs(inputs)
	if (locale === "it") return it_nav_language_cs(inputs)
	if (locale === "sv") return sv_nav_language_cs(inputs)
	if (locale === "nl") return nl_nav_language_cs(inputs)
	if (locale === "da") return da_nav_language_cs(inputs)
	if (locale === "nb") return nb_nav_language_cs(inputs)
	if (locale === "fi") return fi_nav_language_cs(inputs)
	if (locale === "pl") return pl_nav_language_cs(inputs)
	if (locale === "ru") return ru_nav_language_cs(inputs)
	if (locale === "tr") return tr_nav_language_cs(inputs)
	if (locale === "hi") return hi_nav_language_cs(inputs)
	if (locale === "id") return id_nav_language_cs(inputs)
	if (locale === "ms") return ms_nav_language_cs(inputs)
	if (locale === "cs") return cs_nav_language_cs(inputs)
	if (locale === "el") return el_nav_language_cs(inputs)
	if (locale === "he") return he_nav_language_cs(inputs)
	if (locale === "af") return af_nav_language_cs(inputs)
	if (locale === "hu") return hu_nav_language_cs(inputs)
	return en_nav_language_cs(inputs)
});